import { theme } from '$theme';
import styled from '@emotion/styled';

export const StyledActOnBehalfLabel = styled.label({
    fontWeight: theme.fontWeights.regular,
    fontSize: theme.fontSizes.xs,
});
